//@ts-nocheck

import * as React from 'react'
import { Helmet, HelmetProvider } from 'react-helmet-async'
import { QueryClient, QueryClientProvider } from 'react-query'
import { BrowserRouter as Router } from 'react-router-dom'
import { Slide, toast, ToastContainer } from 'react-toastify'
import { GridProvider } from '@faceless-ui/css-grid'

import { InAppBrowserListener } from '@components/elements/InAppBrowserListener'
import { OnRouteChange } from '@components/elements/OnRouteChange'
import { ActivationRequestProvider } from '@components/providers/ActivationRequest'
import { AppConfigProvider } from '@components/providers/AppConfig'
import { AuthProvider } from '@components/providers/Auth'
import { DialogProvider } from '@components/providers/Dialogs'
import { NavigationProvider } from '@components/providers/Navigation'
import { NewAddressProvider } from '@components/providers/NewAddress'
import { NewServiceRequestProvider } from '@components/providers/NewServiceRequest'
import { PricingConfigProvider } from '@components/providers/PricingConfig'
import { Routes } from './views/Routes'

import 'react-toastify/dist/ReactToastify.css'
import '@scss/toastify.scss'

export const App: React.FC = () => {
	const queryClient = new QueryClient({
		defaultOptions: {
			queries: {
				refetchOnWindowFocus: false,
				refetchOnMount: true,
				refetchOnReconnect: true,
				staleTime: 30000, // 30 seconds
			},
		},
	})

	return (
		<React.Fragment>
			<GridProvider
				rowGap={{
					s: '2rem',
					m: '2rem',
					l: '2rem',
					xl: '2rem',
				}}
				colGap={{
					s: '2rem',
					m: '2rem',
					l: '2rem',
					xl: '2rem',
				}}
				cols={{
					s: 4,
					m: 12,
					l: 12,
					xl: 12,
				}}
			>
				<HelmetProvider>
					<AppConfigProvider>
						<QueryClientProvider client={queryClient}>
							<PricingConfigProvider>
								<div className="App">
									<Helmet>
										<meta
											charSet="utf-8"
											name="viewport"
											content="width=device-width, initial-scale=1, maximum-scale=1"
										/>
									</Helmet>

									<Router>
										<NavigationProvider>
											<DialogProvider>
												<OnRouteChange />
												<InAppBrowserListener />

												<AuthProvider>
													<NewAddressProvider>
														<ActivationRequestProvider>
															<NewServiceRequestProvider maxSteps={8}>
																<Routes />
															</NewServiceRequestProvider>
														</ActivationRequestProvider>
													</NewAddressProvider>
												</AuthProvider>
											</DialogProvider>
										</NavigationProvider>
									</Router>
								</div>
							</PricingConfigProvider>
						</QueryClientProvider>
					</AppConfigProvider>
				</HelmetProvider>
			</GridProvider>
			<ToastContainer
				position={toast.POSITION?.BOTTOM_CENTER}
				transition={Slide}
				autoClose={2000}
			/>
		</React.Fragment>
	)
}
